import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    auditList: []
  },
  mutations: {
    setAuditList(state, payload) {
      const loadedAt = Date.now();
      state.auditList = Array.isArray(payload)
        ? payload.map((item) => ({
          ...item,
          _loadedAt: loadedAt
        }))
        : [];
    }
  },
  actions: {
    list({ commit }, query) {
      return api.getWithdrawList(query).then(({ data }) => {
        commit('setAuditList', data === '没有数据' ? [] : data);
      });
    },
    deleteLimit(context, data) {
      return api.deleteWithdrawLimit(data);
    }
  }
};

appStore.registerModule('authLimit', store);
